import axios from 'axios';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';
import authAxios from 'src/modules/shared/axios/authAxios';
import { AuthToken } from 'src/modules/auth/authToken';

export default class AchievementService {
  static async update(id, data) {
    const body = {
      id,
      data,
    };

    const response = await authAxios.put(
      `/achievement/${id}`,
      body,
    );

    return response.data;
  }

  static async destroy(id) {
    const response = await authAxios.delete(
      `/achievement/${id}`,
    );

    return response.data;
  }

  static async create(data) {
    const body = {
      data,
    };

    const response = await authAxios.post(
      `/achievement`,
      body,
    );

    return response.data;
  }

  static async import(values, importHash) {
    const body = {
      data: values,
      importHash,
    };

    const response = await authAxios.post(
      '/achievement/import',
      body,
    );

    return response.data;
  }

  static async find(id) {
    const response = await authAxios.get(`/achievement/${id}`);
    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const response = await authAxios.get('/achievement/listPagination', {
      params,
    });

    return response.data;
  }

  static async listAutocomplete(query, limit) {
    const params = {
      query,
      limit,
    };

    const response = await authAxios.get(
      '/achievement/autocomplete',
      {
        params,
      },
    );

    return response.data;
  }
} 